import { useCallback } from 'react';

import { useSearchParams } from '@shared/hooks/useSearchParams.hook';

const GROUNDED_QA_SCROLL_PARAM_PATCH = {
  qaRun: undefined,
  qaCitation: undefined,
} as const;

const useClearGroundedQaScrollParams = () => {
  const { changeMany } = useSearchParams();

  return useCallback(() => {
    changeMany(GROUNDED_QA_SCROLL_PARAM_PATCH);
  }, [changeMany]);
};

export default useClearGroundedQaScrollParams;
